import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function MyTeamPage() {
  const router = useRouter();

  useEffect(() => {
    const handleRedirect = () => {
      try {
        const search = router.asPath.includes('?via=')
          ? router.asPath.split('?')[1]
          : '';
        const targetPath = `/my-team/pick${search ? `?${search}` : ''}`;

        router.replace(targetPath);
      } catch (error) {
        console.error('Error handling redirect:', error);

        router.replace('/my-team/pick');
      }
    };

    handleRedirect();
  }, [router]);

  return <div className="min-h-screen bg-gray-100" />;
}
